module.exports = __webpack_public_path__ + "img/emoji-shrugging-25x25.8afefb50.png";